const VersionInfo = () => <p>{process.env.REACT_APP_GIT_SHA || 'Could not get version info'}</p>;

export default VersionInfo;
